<template>
<div class="chapter">
<div class="inner_page">
<p class="chapno" id="id5">Chapter One</p>
<p class="chapname" id="id5a"><span class="bold"> ‘We Go To War’ –April 1917</span></p>
<p class="caption"><span class="bold"><em class="italic">IT IS A FEARFUL THING to lead this great, peaceful country into war, into the most terrible and disastrous of all wars, civilisation itself seeming to be in the balance. But the right is more precious than peace... the day has come when America is privileged to spend her blood and her might for the principles that gave her birth and happiness amid the peace which she has treasured. God helping her. She can do no other.</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01a_AMERICAN_EXPEDITIONARY_FORCE.vue?794218f8